export default __webpack_public_path__ + "static/media/1497.9f531912.png";